import React, { Fragment, useContext } from 'react'
import { I18nextContext } from '@toasttab/shared/src/context/i18nextContext'
import { useI18next } from '@toasttab/shared/src/hooks/useI18next'
import { localizeLink } from '@toasttab/shared/src/utils/linkUtils'
import { FooterLegalLinksProps, FooterLink } from './Footer.d'

const FooterLegalLinks = ({ hostName, legalLinks }: FooterLegalLinksProps) => {
  const { t } = useI18next()
  const localizationContext = useContext(I18nextContext)

  const legalLinkCss =
    'text-secondary hover:text-default font-sansPro font-normal text-xs'

  const renderLegalLink = (menu: FooterLink) => {
    if (menu.href === 'cookie-settings') {
      return (
        <button
          className={`${legalLinkCss} fides-manage-preferences-link`}
          data-testid='FooterLegalLinks-link-preferences'
          id='fides-preferences-link'
          onClick={() => window.Fides?.showModal?.()}
          type='button'
        >
          {t(menu.text)}
        </button>
      )
    } else if (menu.href?.startsWith('http')) {
      return (
        <a
          className={legalLinkCss}
          data-testid='FooterLegalLinks-link-external'
          href={menu.href}
          rel='nofollow'
        >
          {t(menu.text)}
        </a>
      )
    } else if (
      menu.href &&
      !menu.href.startsWith('http') &&
      !menu.href.startsWith('/')
    ) {
      return (
        <a
          className={legalLinkCss}
          data-testid='FooterLegalLinks-link-host'
          href={`${hostName}/${menu.href}`}
          rel='nofollow'
        >
          {t(menu.text)}
        </a>
      )
    } else if (menu.href?.startsWith('/')) {
      return (
        <a
          className={legalLinkCss}
          data-testid='FooterLegalLinks-link-local'
          href={localizeLink(
            menu.href,
            localizationContext.language,
            localizationContext
          )}
        >
          {t(menu.text)}
        </a>
      )
    }
  }

  return (
    <div
      className='pt-8 pb-6 ds-footer-container'
      data-testid='FooterLegalLinks'
    >
      <ul className='flex flex-row flex-wrap items-start lg:justify-between'>
        {legalLinks.map((menu: any, i: number) => {
          return menu.href ? (
            <li
              className='mr-4 mb-4 md:mr-8 lg:mr-0'
              data-testid='FooterLegalLinks-listItem'
              key={menu.text}
            >
              {renderLegalLink(menu)}
            </li>
          ) : (
            <Fragment key={`footer-legal-${i}`} />
          )
        })}
        <li className='text-secondary mb-4 font-sansPro font-normal text-xs leading-[24px]'>
          &copy; {new Date().getFullYear()} Toast, Inc.
        </li>
      </ul>
    </div>
  )
}

export default FooterLegalLinks
